// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { isPresent } from "#ce/utils/props";

/** Disables native and sp-select controls inside rendered visual forms. */
export function disableFormBuilderInputs(root) {
  for (const control of root.querySelectorAll(
    ".form-builder-container :is(input, select, textarea, button, sp-select)",
  )) {
    control.setAttribute("disabled", "");
  }
}

/** Copies live select data to cloned hosts before they mount. */
function copySelectValues(source, destination) {
  const originals = selectControls(source);
  const clones = selectControls(destination);

  for (const [index, control] of originals.entries()) {
    const clone = clones[index];
    const multiple = control.type === "select-multiple";
    const value = control.value ?? (multiple ? [] : "");

    clone.toggleAttribute("multiple", multiple);
    clone.setAttribute("value", Array.isArray(value) ? JSON.stringify(value) : String(value));
    clone.value = Array.isArray(value) ? [...value] : value;

    if (Array.isArray(control.items)) {
      clone.setAttribute("items", JSON.stringify(control.items));
      clone.items = control.items;
    }
  }
}

/** Copies the live select data of each source root to the clone at the same index. */
export function copyFormSelectValues(sources, clones) {
  for (const [index, root] of Array.from(sources).entries()) {
    copySelectValues(root, clones[index]);
  }
}

/** Disables the sp-selects in a review and hides the container of a required one left empty. */
export function disableReviewSelects(root) {
  for (const control of root.querySelectorAll("sp-select")) {
    control.setAttribute("disabled", "");

    if (isPresent(control.required ?? control.getAttribute("required")) && String(control.value ?? "") === "") {
      control.parentElement.style.display = "none";
    }
  }
}

function selectControls(root) {
  return root.matches("sp-select") ? [root] : Array.from(root.querySelectorAll("sp-select"));
}
